<app-q1-feedback-layout>
  <div class="wrap">
    <img class="icon" src="/assets/img/game/select.svg">
    <div class="text-wrap">
      <div>Fantastic! You've made excellent selections.</div>
      <div>While all of your choices are valid, <span *ngIf="incorrectShops.length > 1">there are <span class="pink">{{ incorrectShops.length }}</span> more stores</span><span *ngIf="incorrectShops.length === 1">there is <span class="pink">1</span> more store</span> we're going to focus on in this simulation. Here's why:</div>
    </div>
    <div class="info-helpers">
      <app-q1-feedback-retailer-tile
        *ngFor="let shop of incorrectShops"
        [shopId]="shop.id"
        [feedback]="shop.feedback"
        (infoClicked)="onNavigateToSlider($event)"
      ></app-q1-feedback-retailer-tile>
    </div>
    <div class="text-wrap">
      <div class="pink">Please begin your journey by tapping below.</div>
    </div>
    <app-button
      [text]="'Continue'"
      (click)="onContinueClick()"
      ></app-button>
  </div>
</app-q1-feedback-layout>